import styled from "styled-components";
import { Typography } from "@mui/material";

export const TypographyText = styled(Typography)`
  && {
    font-size: 18px;
    font-weight: 400;
    font-family: Poppins Regular;
    color: var(--black);
    text-align: left;
  }
`;
